module.exports = __webpack_public_path__ + "static/img/kh-2.ff34ba9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-2.png
// module id = h4Ow
// module chunks = 4